import React, { useEffect, useRef, useState } from "react";
import { Modal, Form, Input, Switch, Row, Col, message } from "antd";
import {
  addPharmacyConfigApi,
  updatePharmacyConfigApi,
} from "../../../services/pharmacyConfigs.services";
import {
  gstinRules,
  mobileRules,
  nameRules,
  panRules,
  websiteRules,
} from "../common/validators";

const VendorFormModal = ({ open, setOpen, editData, refreshPage }) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (editData) {
      form.setFieldsValue(editData);
    } else {
      form.resetFields();
    }
  }, [editData]);

  const closeAndReset = () => {
    form.resetFields();
    setOpen(false);
  };

  const onFinish = (values) => {
    setLoading(true);
    const apiCall = editData?.id
      ? updatePharmacyConfigApi("vendors", editData.id, values)
      : addPharmacyConfigApi("vendors", values);

    apiCall
      .then((res) => {
        message.success(`Vendor ${editData?.id ? "updated" : "added"} successfully`);
        setLoading(false);
        closeAndReset();
        /*
         * The saved vendor is handed back, not just the fact that one was
         * saved. A list only needs to reload; a form that opened this modal to
         * fill its own vendor field needs the record to put in it.
         */
        refreshPage(res?.data?.data ?? res?.data);
      })
      .catch((err) => {
        message.error(err?.response?.data?.message || "Failed to save Vendor");
        setLoading(false);
      });
  };

  return (
    <Modal
      title={editData?.id ? "Edit Vendor" : "Add Vendor"}
      open={open}
      onCancel={closeAndReset}
      centered
      width={640}
      destroyOnClose
      okText="Save"
      confirmLoading={loading}
      onOk={() => formRef.current?.submit()}
    >
      <Form layout="vertical" form={form} ref={formRef} onFinish={onFinish}>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Name"
              name="name"
              rules={nameRules("Vendor")}
            >
              <Input placeholder="Vendor Name" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Mobile" name="mobile" rules={mobileRules}>
              <Input placeholder="Mobile" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Email"
              name="email"
              rules={[{ type: "email", message: "Enter a valid email" }]}
            >
              <Input placeholder="Email" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Website" name="website" rules={websiteRules}>
              <Input placeholder="Website" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="GSTIN" name="gstin" rules={gstinRules}>
              <Input placeholder="GSTIN" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="PAN" name="pan" rules={panRules}>
              <Input placeholder="PAN" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="State" name="state">
              <Input placeholder="State" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Active"
              name="is_active"
              valuePropName="checked"
              initialValue
            >
              <Switch />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default VendorFormModal;
